/* ------------------------------------------------------------------
   DIRE VULF — footer behaviour.

   Two jobs, both progressive enhancements. With JavaScript off the
   footer still works: the link columns render open, and the back-to-top
   button stays hidden rather than sitting there doing nothing.

   1. Link columns collapse below 750px. They are <details> elements
      rendered open, so no-JS users see every link.
   2. Back to top. Scroll position is read on a plain timer rather than
      requestAnimationFrame so the button also settles correctly on
      pages that are restored from bfcache or never painted a frame.
   3. A link to #dv-who-we-are opens that accordion. Browsers only
      auto-expand a <details> when the target is inside it, and here the
      id is on the element itself, so the footer does it explicitly.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SMALL = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- collapsible columns ---- */

  var cols = document.querySelectorAll('[data-dv-fcol]');

  function syncCols() {
    for (var i = 0; i < cols.length; i++) {
      cols[i].open = !SMALL.matches;
    }
  }

  if (cols.length) {
    syncCols();
    if (SMALL.addEventListener) {
      SMALL.addEventListener('change', syncCols);
    } else if (SMALL.addListener) {
      SMALL.addListener(syncCols);
    }
  }

  /* ---- open "Who we are" when linked to directly ---- */

  function openFromHash() {
    if (window.location.hash !== '#dv-who-we-are') { return; }
    var who = document.getElementById('dv-who-we-are');
    if (!who) { return; }
    who.open = true;
    var behavior = REDUCE.matches ? 'auto' : 'smooth';
    try {
      who.scrollIntoView({ block: 'start', behavior: behavior });
    } catch (e) {
      who.scrollIntoView();
    }
  }

  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  /* ---- back to top ---- */

  var btn = document.querySelector('[data-dv-totop]');
  if (!btn) { return; }

  btn.hidden = false;

  function scrollY() {
    return window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop || 0;
  }

  function apply() {
    btn.classList.toggle('is-on', scrollY() > 420);
  }

  var last = 0;
  var timer = null;

  function onScroll() {
    var now = Date.now();
    if (now - last < 120) {
      if (timer) { clearTimeout(timer); }
      timer = setTimeout(function () { last = Date.now(); apply(); }, 120);
      return;
    }
    last = now;
    apply();
  }

  apply();

  /* The page scrolls the viewport, whose scroll event reaches the window.
     A second, capturing listener on the document used to run as well: it
     fired again for the same page scroll, and also for every horizontal
     scroll inside the product carousels, none of which move the page. */
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', apply);

  btn.addEventListener('click', function () {
    var behavior = REDUCE.matches ? 'auto' : 'smooth';
    try {
      window.scrollTo({ top: 0, left: 0, behavior: behavior });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    document.documentElement.scrollTop = 0;
    if (document.body) { document.body.scrollTop = 0; }
    apply();

    /* Send focus back to the top of the page, not just the viewport. */
    var target = document.querySelector('#MainContent, main, header');
    if (target) {
      if (!target.hasAttribute('tabindex')) { target.setAttribute('tabindex', '-1'); }
      try { target.focus({ preventScroll: true }); } catch (e2) { target.focus(); }
    }
  });
})();